import { render, staticRenderFns } from "./tBurial.vue?vue&type=template&id=01c13926&scoped=true"
import script from "./tBurial.vue?vue&type=script&lang=js"
export * from "./tBurial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c13926",
  null
  
)

export default component.exports